// extracted by mini-css-extract-plugin
var _1 = "modalStatementDetail-module_agreement__gBEvxJ";
var _2 = "modalStatementDetail-module_dialogActions__qW1s_l";
var _3 = "modalStatementDetail-module_dialogContnent__NCBPdC";
var _4 = "modalStatementDetail-module_dialog_paper__E4MtLo";
var _5 = "modalStatementDetail-module_input__eFvbCF";
var _6 = "modalStatementDetail-module_notificationCheckbox__ozAtwv";
export { _1 as "agreement", _2 as "dialogActions", _3 as "dialogContnent", _4 as "dialog_paper", _5 as "input", _6 as "notificationCheckbox" }
